import React from "react";

const ArrowIcon: React.FC<{ className?: string }> = ({ className }) => (
  <svg
    width="12"
    height="14"
    viewBox="0 0 12 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.32342 5.42131L0 0H12L9.67658 5.42131C8.29125 8.65374 3.70875 8.65374 2.32342 5.42131Z"
      fill="#17142A"
    />
  </svg>
);

export default ArrowIcon;
